import React, { useState, useEffect } from 'react';
import { doc, updateDoc, deleteDoc, getDocs, query, collection, addDoc, where } from 'firebase/firestore';
import { db } from '../../firebase-config'
import '../../Styles/YearlyTaskComponent.css'
import '../../Styles/button.css'

function YearlyTaskComponent({ selectedYear, selectedCompany, isAdmin }) {
    const [tasks, setTasks] = useState([]);
    const [newTask, setNewTask] = useState({ title: '', content: '' });
    const [editedTitle, setEditedTitle] = useState('');
    const [editedContent, setEditedContent] = useState('');

    useEffect(() => {
        fetchTasks();
    }, [selectedYear, selectedCompany]);

    const fetchTasks = async () => {
        const q = query(collection(db, 'yearlyTasks'), where('company', '==', selectedCompany), where('year', '==', selectedYear));
        const querySnapshot = await getDocs(q);
        const fetchedTasks = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setTasks(fetchedTasks);
    };

    const addTask = async () => {
        if (newTask.title.trim() === '' || newTask.content.trim() === '') return;
        await addDoc(collection(db, 'yearlyTasks'), { ...newTask, company: selectedCompany, year: selectedYear });
        setNewTask({ title: '', content: '' });
        fetchTasks(); 
    };

    const handleNewTaskChange = (field, value) => {
        setNewTask(prev => ({ ...prev, [field]: value }));
    };

    const handleTitleChange = async (taskId, title) => {
        await updateDoc(doc(db, 'yearlyTasks', taskId), { title });
        fetchTasks();
    };
    
    const handleContentChange = async (taskId, content) => {
        await updateDoc(doc(db, 'yearlyTasks', taskId), { content });
        fetchTasks();
    };
    
    const deleteTask = async (taskId) => {
        await deleteDoc(doc(db, 'yearlyTasks', taskId));
        fetchTasks(); 
    };

    return (
        <>
        <div className="yearlyTasksContainer">
            
            {tasks.map(task => (
                <div key={task.id} className="taskContainer">
                    <p className='textTitle'>Årlig Opgave:</p>
                    {isAdmin ? (
                        <>
                    <textarea
                        value={editedTitle[task.id] || task.title}
                        onChange={(e) => setEditedTitle({ ...editedTitle, [task.id]: e.target.value })}
                        onBlur={() => handleTitleChange(task.id, editedTitle[task.id] || task.title)}
                        className='textarea-title'
                        
                    />
                    <textarea
                        value={editedContent[task.id] || task.content}
                        onChange={(e) => setEditedContent({ ...editedContent, [task.id]: e.target.value })}
                        onBlur={() => handleContentChange(task.id, editedContent[task.id] || task.content)}
                        className='textarea-content'
                        
                    />
                </>
                    ) : (
                        <div className='readonly-task'>
                            <p className='textTitle'>{task.title}</p>
                            <p className='textContent'>Hvordan vi løser den <br></br> {task.content}</p>
                        </div>
                    )}
                    {isAdmin && <button className='delete-btn' onClick={() => deleteTask(task.id)}>Delete Task</button>}
                </div>
            ))}
            {isAdmin && (
                <div className='taskContainer'>
                    <p className='textTitle'>Opret ny opgave</p>
                    <textarea 
                        className='textarea-title'
                        placeholder='Title'
                        value={newTask.title}
                        onChange={(e) => handleNewTaskChange('title', e.target.value)}
                        style={{border: "1px solid #ccc", padding: "5px", width: "100%", resize: 'none'}}
                    />
                    <textarea
                        className='textarea-content'
                        placeholder='Content'
                        value={newTask.content}
                        onChange={(e) => handleNewTaskChange('content', e.target.value)}
                        style={{border: "1px solid #ccc", padding: "5px", width: "100%", resize: 'none'}}
                    />
                    <button className='add-btn' onClick={addTask}>Add Task</button>
                </div>
            )}
        </div>
        </>
    );
}
    
    export default YearlyTaskComponent;